/**
 * @file test-plan.form.tsx
 * @description Форма для создания и редактирования тестовых планов в системе тестирования.
 * Включает поля для указания сервиса, URL запроса, тела запроса, 
 * логина и пароля для аутентификации.
 * Позволяет настраивать параметры подключения и авторизации для автоматизированного тестирования.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @components/form-controls/collapsed/dictionary]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx, @components/form-controls/collapsed/dictionary/dictionary.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { Dictionary } from '@components/form-controls/collapsed/dictionary';

export const TestPlanForm = ({ control }: any) => {
    return (
        <>
            <Dictionary label="Сервис" name="service" control={control} />

            <TextField label="URL" name="url" control={control} />

            <TextField label="BODY" type="textarea" minRows={6} name="body" withClearButton={false} control={control} />

            <TextField label="Логин" name="login" control={control} />

            <TextField label="Пароль" type="password" name="pass" control={control} />
        </>
    );
};
